import React from 'react';

const BackofficeTopbar = ({ username, roleName, liveDate, theme, onToggleTheme, onLogout }) => {
  const userLabel = username && roleName
    ? `User: ${username} • ${roleName}`
    : (username ? `User: ${username}` : (roleName ? `Role: ${roleName}` : ''));
  const subtitle = roleName ? `${roleName} Approval Desk` : 'Approval Desk';

  return (
    <header className="topbar">
      <div className="brand-block">
        <div className="brand-main">SLACC</div>
        <div className="brand-sub">Sindh Legal Advisory Call Center</div>
      </div>
      <div className="title-block">
        <h1>Backoffice Admin Panel</h1>
        <p>{subtitle}</p>
      </div>
      <div className="meta-block">
        {userLabel ? <span className="meta-pill">{userLabel}</span> : null}
        {liveDate ? <span className="meta-pill">{liveDate}</span> : null}
        <button type="button" className="btn btn-soft" onClick={onToggleTheme}>
          {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
        </button>
        <button type="button" className="btn btn-danger" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default BackofficeTopbar;
